//import './less/topBar.less';

const topBar = () => {
};

export { topBar };


// WEBPACK FOOTER //
// ../components/topBar/topBar.js